import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    dict,
    user,
    tagsView,
  },
  getters,
  state: {
    // 用户信息
    userInfo: {
      // "searchValue": null,
      // "createBy": "admin",
      // "createTime": "2025-01-23 17:38:10",
      // "updateBy": null,
      // "updateTime": null,
      // "remark": "管理员",
      // "params": {
      //   "@type": "java.util.HashMap"
      // },
      // "userId": 1,
      // "deptId": 100,
      // "userName": "admin",
      // "nickName": "版灯",
      // "email": "bandeng@163.com",
      // "phonenumber": "15888888888",
      // "sex": "1",
      // "avatar": "png/395c3cb745094df9912fa302c0125442",
      // "password": "$2a$10$nqM3oF3t6nHbXGFPshRAkOJRFuVdtDqftw.PulUr..ezOwQ7TBg1S",
      // "status": "0",
      // "delFlag": "0",
      // "loginIp": "113.108.77.65",
      // "loginDate": "2025-02-28T17:31:52.000+08:00",
      // "dciUserId": "DUSANDBOX8250207000000697929",
      // "dciUserStatus": "FINISH",
      // "bossUserId": null,
      // "roleIds": null,
      // "postIds": null,
      // "roleId": null,
      // "admin": true

    },
    //实名信息
    realInformation: {
      // "searchValue": null,
      // "createBy": "admin",
      // "createTime": "2025-02-12 15:53:38",
      // "updateBy": "admin",
      // "updateTime": "2025-02-17 09:53:57",
      // "remark": null,
      // "userId": 1,
      // "dciUserId": "DUSANDBOX8250207000000697929",
      // "dciUserStatus": "FINISH",
      // "certName": "刘卫东",
      // "certificateNumber": "513722199610162278",
      // "certificateType": "IDENTITY_CARD",
      // "certificateFrontFileId": "202502121525937265285b174f9895a03f7166f9b2ed17ead66892ae4ac7b9497c86d090bd4e.jpg",
      // "certificateFrontFileIdLocal": "jpg/78e7c945bcde47b78feda50f0c4517e7",
      // "certificateBackFileId": "20250212152428f55d4a405ee6c12d10d9217581617327fb8a922e4068a4ccc587ee91771b55.jpg",
      // "certificateBackFileIdLocal": "jpg/8c434c81ed8d4ab2a962b3460b4b7d91",
      // "legalPersonCertName": "",
      // "legalPersonCertType": "",
      // "legalPersonCertNo": "",
      // "phone": "17783376464",
      // "certificateStartTime": "2024-09-27T00:00:00.000+08:00",
      // "certificateEndTime": "2044-09-27T00:00:00.000+08:00",
      // "identityStartTime": "1996-10-16T00:00:00.000+08:00",
      // "longTermValid": null,
      // "address": "重庆市渝中区虎山路90号10幢2单元1-1",
      // "clientToken": "8f627b51c30c424faf13c55ee4333992",
      // "areaType": "CHINA_MAINLAND"
    },
  },
})

export default store
